import React, { createContext, useState } from 'react';

export const UserContext = createContext();

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user')) || null;
  } catch {
    return null;
  }
};

export const UserProvider = ({ children, initialUser }) => {
  const [user, setUser] = useState(initialUser ?? getStoredUser());

  const updateUserContext = (newUser) => {
    setUser(newUser);
  };

  return (
    <UserContext.Provider value={{ user, updateUserContext }}>
      {children}
    </UserContext.Provider>
  );
};
